@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@s-ui/react-atom-checkbox/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@s-ui/react-molecule-checkbox-field/lib/index';
@import '~@s-ui/react-atom-radio-button/lib/index';
@import '~@s-ui/react-atom-textarea/lib/index';
@import '~@adv-mt/mt-spinner-basic/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-atom-skeleton/lib/index';

$w-image: 256px;
$h-image: 180px;
$w-site-logo: 109px;
$w-site-logo-desktop: 150px;
$mih-checkbox-section: 197px;
$mih-image: 180px;
$mih-loader: 158px;
$mih-pretitle: 28px;
$w-image-desktop: 330px;
$miw-checkbox-section: 582px;

.mt-UserUnsubscribeEmails {
  display: grid;
  grid-template:
    'logo'
    'image'
    'pretitle'
    'title'
    'checkboxSection'
    'radioButtonsForm'
    'buttons';

  margin: $m-l 0;

  @include media-breakpoint-up(s) {
    grid-template:
      'logo .'
      'pretitle .'
      'title image'
      'checkboxSection image'
      'radioButtonsForm .'
      'buttons .';

    margin: $m-l;
  }

  &--isSuccess {
    grid-template:
      'logo'
      'image'
      'pretitle'
      'title'
      'succesFullDescrciption'
      'buttons';

    @include media-breakpoint-up(s) {
      grid-template:
        'logo .'
        'pretitle .'
        'title image'
        'succesFullDescrciption image'
        'buttons image';

      margin: $m-l;

      > .mt-UserUnsubscribeEmails-buttonsContainer {
        justify-content: flex-end;
      }
    }
  }

  &-buttonsContainer {
    align-items: center;
    background-color: $c-white;
    display: flex;
    flex-direction: column;
    grid-area: buttons;
    width: 100%;

    @include media-breakpoint-up(l) {
      align-items: baseline;
      flex-direction: row-reverse;
      justify-content: space-between;
    }
  }

  &-checkbox {
    display: flex;
    gap: 12px;
    padding: $p-l 0 $p-m;
  }

  &-infoLink {
    margin-top: $m-l;
    @include media-breakpoint-up(l) {
      margin-top: 0;
    }
  }

  &-label {
    font-size: $fz-l;
  }

  &-checkboxSection {
    grid-area: checkboxSection;
    display: flex;
    flex-direction: column;
    margin-top: $m-xxl;
    min-height: $mih-checkbox-section;

    @include media-breakpoint-up(l) {
      margin-bottom: $m-xxl;
      min-height: auto;
      min-width: $miw-checkbox-section;
    }
  }

  &-checkboxSectionTitle {
    font-size: $fz-l;
    margin-bottom: $m-m;
  }

  &-image {
    grid-area: image;
    height: $h-image;
    margin: 0 auto $m-xl;
    width: $w-image;

    @include media-breakpoint-up(s) {
      margin: 0 0 $m-giant $m-xl;
      width: $w-image-desktop;
    }
  }

  &-loader {
    grid-area: loader;
    min-height: $mih-loader;
  }

  &-pretitle {
    font-size: $fz-l;
    grid-area: pretitle;
    line-height: $lh-xl;
    margin-bottom: $m-m;
    min-height: $mih-pretitle;
  }

  &-radioButton {
    display: flex;
    gap: 12px;
    padding: $p-l 0 $p-m;
  }

  &-radioButtonsForm {
    border: $bdw-s solid $c-gray-light-1;
    border-radius: $bdrs-l;
    grid-area: radioButtonsForm;
    margin: 0 0 $m-xxl;
    padding: $p-l;

    @include media-breakpoint-up(s) {
      padding: $p-xxl;
    }
  }

  &-radioButtonsTitle {
    margin-bottom: $m-l;
  }

  &-siteLogo {
    grid-area: logo;
    margin-bottom: $m-xl;
    width: $w-site-logo;

    @include media-breakpoint-up(s) {
      margin-bottom: $m-giant;
      width: $w-site-logo-desktop;
    }
  }

  &-succesFullDescrciption {
    grid-area: succesFullDescrciption;
    font-size: $fz-l;
    margin: $m-xxl 0 $m-l;

    @include media-breakpoint-up(s) {
      margin: $m-xl 0 0;
    }
  }

  &-textArea {
    padding-top: $p-s;
  }

  &-title {
    grid-area: title;
  }
}
